function lazyLoadSection() {
  const scrollRevealSections = document.querySelectorAll('.js-lazyload-section');

  const observerConfig = {
    root: null,
    rootMargin: '0px',
    threshold: 0.01
  };

  let observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const lazyElement = entry.target,
          section = lazyElement.parentElement,
          templateElement = section.querySelector('.js-section-html');

        const templateHTML = templateElement.content.firstElementChild.cloneNode(true).innerHTML;

        if (templateHTML) {
          section.innerHTML = templateHTML;

          requirejs(['lazyload1'], function() {
            if (updateLazyLoad) updateLazyLoad();
          })

          observer.unobserve(entry.target);
        }
      }
    });
  }, observerConfig);

  scrollRevealSections.forEach((section) => observer.observe(section));
}

lazyLoadSection();
// window.addEventListener('load', () => {
//   lazyLoadSection();
// });
